import React, { useState, useEffect } from "react";
import {Modal, Typography, Row, Col, Form, Input, Button, DatePicker,} from "antd";
import { putOrderDetailEdit } from "../../../../../../services/orderManagement.service";
import { swalNotification } from "../../../../../../components/alret/notificztion";
import { validationErrors } from "../../../../../../utils/Helpers";
import moment from "moment";

const { Title, Text } = Typography;

const ModalEditOrder = (props) => {
  const [postDataOrderView, setPostDataOrderView] = useState(null);
  const [postDataOrderIDF, setPostDataOrderIDF] = useState(null);
  const [postDataOrderIDS, setPostDataOrderIDS] = useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);

  useEffect(() => {
    if (props.visible) {
      postLists();
    }
  }, [props.visible]);
  const postLists = async () => {
    try {
      setMBtnLoading(true);
      dataConvert(props.orderData);
      const dataConvertID = [];
      props.orderData.map((item) => {
        const dataid = {
          id: item.id,
        };
        dataConvertID.push(dataid);
      });
      setPostDataOrderIDF(dataConvertID[0].id);
      setPostDataOrderIDS(dataConvertID[1].id);
    } catch {
      // setErrMsg("Something went wrong");
    } finally {
      setMBtnLoading(false);
    }
  };
  const dataConvert = (values) => {
    values.map((item, idx) => {
      const editOrderData = {
        pickup: item.pickup,
        delivery: item.delivery,
      };
      setPostDataOrderView(editOrderData);
    });
  };

  const handleCancel = () => {
    props.setvisible(false);
  };
  // Modal Form

  const okhandlePickup = async (values) => {
    try {
      await putOrderDetailEdit(postDataOrderIDF, values);
    } catch (e) {
      // console.log("resp at handleCancelPickup =>> ", e);
      throw e;
    }
  };
  const okhandleDeliver = async (values) => {
    try {
      await putOrderDetailEdit(postDataOrderIDS, values);
    } catch (e) {
      throw e;
    }
  };

  const onFinish = async (values) => {
    if (values.delivery.datetimes != "") {
      values.delivery.datetime = moment(values.delivery.datetimes._d)
        // .add("hours", 5)
        .toISOString();
    }
    if (values.pickup.datetimes != "") {
      values.pickup.datetime = moment(values.pickup.datetimes._d)
        // .add("hours", 5)
        .toISOString();
    }
    // console.log("Submit", values);
    // return null;
    // const headers = {
    //   "Content-Type": "application/json",
    // };
    try {
      setMBtnLoading(true);
      await okhandlePickup(values);
      await okhandleDeliver(values);
      swalNotification(
        "Order Changes",
        "Order has been Change successfully",
        "success"
      );
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }

    // postDataOrderEditID;
  };

  useEffect(() => {
    form.setFieldsValue(postDataOrderView);
  }, [postDataOrderView]);
  const [form] = Form.useForm();

  return (
    <Modal
      title="Edit Order"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button
          form="modalFormEditTask"
          loading={MBtnLoading}
          htmlType="submit"
          //  disabled={postDataReason == null}
        >
          Save
        </Button>,
      ]}
    >
      {postDataOrderView && (
        <Form
          form={form}
          id="modalFormEditTask"
          layout="vertical"
          initialValues={postDataOrderView}
          onFinish={onFinish}
        >
          <Form.List name={"pickup"}>
            {(fields) => (
              <Row>
                <Col span={24}>
                  <Title level={5}>Pickup</Title>
                </Col>
                <Col span={12}>
                  <Text>Phone</Text>
                  <Form.Item
                    name={"phone"}
                    rules={[{ required: true, message: "Phone is Required" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Date Time</Text>
                  <Form.Item
                    name="datetimes"
                    rules={[
                      {
                        required: true,
                        message: "Date Time is Required",
                      },
                    ]}
                    initialValue={moment(postDataOrderView.pickup.datetime)}
                  >
                    <DatePicker
                      format="YYYY-MM-DD HH:mm:ss"
                      showTime
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Latitude</Text>
                  <Form.Item
                    name={"latitude"}
                    rules={[
                      {
                        required: true,
                        message: "Latitude is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Longitude</Text>
                  <Form.Item
                    name={"longitude"}
                    rules={[
                      {
                        required: true,
                        message: "Longitude is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Text>Pickup Address</Text>

                  <Form.Item
                    name={"address"}
                    rules={[
                      {
                        required: true,
                        message: "Address is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Form.List>
          <Form.List name={"delivery"}>
            {(fields) => (
              <Row>
                <Col span={24}>
                  <Title level={5}>Delivery</Title>
                </Col>
                <Col span={12}>
                  <Text>Name</Text>
                  <Form.Item
                    name={"username"}
                    rules={[
                      {
                        required: true,
                        message: "Name is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Email</Text>
                  <Form.Item
                    name={"email"}
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: "Email is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Phone</Text>
                  <Form.Item
                    name={"phone"}
                    rules={[
                      {
                        required: true,
                        message: "Phone is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Date Time</Text>
                  <Form.Item
                    name="datetimes"
                    rules={[
                      {
                        required: true,
                        message: "Date Time is Required",
                      },
                    ]}
                    initialValue={moment(postDataOrderView.pickup.datetime)}
                  >
                    <DatePicker
                      format="YYYY-MM-DD HH:mm:ss"
                      showTime
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Latitude</Text>
                  <Form.Item
                    name={"latitude"}
                    rules={[
                      {
                        required: true,
                        message: "Latitude is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Longitude</Text>
                  <Form.Item
                    name={"longitude"}
                    rules={[
                      {
                        required: true,
                        message: "Longitude is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Text>Delivery Address</Text>
                  <Form.Item
                    name={"address"}
                    rules={[
                      {
                        required: true,
                        message: "Address is Required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Form.List>
        </Form>
      )}

      {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3619.9941193872733!2d67.06768836492677!3d24.86405043405225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e9f6423960d%3A0x95c1b29bacc7619!2sBlock-6%20Block%206%20PECHS%2C%20Karachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1663065619439!5m2!1sen!2s"
            width="600"
            height="100%"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe> */}
    </Modal>
  );
};
export default ModalEditOrder;
